import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from 'nuka-carousel';

import { breakSmall } from '../../../const';

import './Caro.css';

/**
 * Caro
 * @constructor
 * @param {prop} data - Items
 * @param {prop} respSlidesToShow - Responsive Slides to Show
 * @param {prop} slidesToShow - Slides to Show
 * @param {prop} frameOverflow - Show Overflow
 * @param {prop} data - Items
 */

class Caro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            slidesToShow:
                window.innerWidth < breakSmall
                    ? props.respSlidesToShow
                    : props.slidesToShow,
            slidesToScroll: props.slidesToScroll,
            slideIndex: 0,
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize, false);
        this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false);
    }

    /**
     * Tied to the resize event on window
     */
    onResize = e => {
        this.throttledResize(e);
    };
    /**
     * Throttled resize function, handles resetting slidesToShow count
     */
    throttledResize = e => {
        const { respSlidesToShow, slidesToShow } = this.props;
        this.setState({
            slidesToShow:
                window.innerWidth < breakSmall
                    ? respSlidesToShow
                    : slidesToShow,
        });
    };

    render() {
        const { slidesToShow, slidesToScroll } = this.state;
        const {
            frameOverflow,
            framePadding,
            insertClass,
            cellSpacing,
            color,
            initialSlideHeight,
            dragging,
            withoutControls,
            autoplay,
            autoplayInterval,
        } = this.props;
        return (
            <div className={'caro ' + insertClass + ' mod-' + color}>
                <Carousel
                    scrollMode='page'
                    frameOverflow={'' + frameOverflow + ''}
                    framePadding={framePadding}
                    cellSpacing={cellSpacing}
                    slidesToShow={slidesToShow}
                    slidesToScroll={slidesToScroll}
                    slideIndex={this.state.slideIndex}
                    initialSlideHeight={initialSlideHeight}
                    afterSlide={slideIndex => this.setState({ slideIndex })}
                    height='100%'
                    withoutControls={withoutControls}
                    dragging={dragging}
                    autoplay={autoplay}
                    autoplayInterval={autoplayInterval}
                    renderCenterLeftControls={({ previousSlide }) => {
                        if (this.state.slideIndex > 0) {
                            return (
                                <button
                                    className='caro-transport caro-transport-prev'
                                    onClick={previousSlide}
                                >
                                    <svg viewBox='0 0 10.55 17.43'>
                                        <path
                                            className='cls-1'
                                            d='M1.23,3.06,8,9.79,1.23,16.52a.51.51,0,0,0,0,.72l1.11,1.12a.51.51,0,0,0,.72,0l8.57-8.57L3.06,1.23a.51.51,0,0,0-.72,0L1.23,2.34A.51.51,0,0,0,1.23,3.06Z'
                                            transform='translate(-1.08 -1.08)'
                                        />
                                    </svg>
                                </button>
                            );
                        }
                    }}
                    renderCenterRightControls={({ nextSlide }) => {
                        if (
                            this.state.slideIndex <
                            this.props.children.length - 1
                        ) {
                            return (
                                <button
                                    className='caro-transport caro-transport-next'
                                    onClick={nextSlide}
                                >
                                    <svg viewBox='0 0 10.55 17.43'>
                                        <path
                                            className='cls-1'
                                            d='M1.23,3.06,8,9.79,1.23,16.52a.51.51,0,0,0,0,.72l1.11,1.12a.51.51,0,0,0,.72,0l8.57-8.57L3.06,1.23a.51.51,0,0,0-.72,0L1.23,2.34A.51.51,0,0,0,1.23,3.06Z'
                                            transform='translate(-1.08 -1.08)'
                                        />
                                    </svg>
                                </button>
                            );
                        }
                    }}
                >
                    {this.props.children}
                </Carousel>
            </div>
        );
    }
}

Caro.propTypes = {
    respSlidesToShow: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
    children: PropTypes.array,
    frameOverflow: PropTypes.bool,
    framePadding: PropTypes.string,
    insertClass: PropTypes.string,
    cellSpacing: PropTypes.string,
    disableEdgeSwiping: PropTypes.bool,
    initialSlideHeight: PropTypes.number,
    color: PropTypes.string,
    dragging: PropTypes.bool,
    withoutControls: PropTypes.bool,
    autoplay: PropTypes.bool,
    autoplayInterval: PropTypes.number
};

export default Caro;
